


import React, { useState, useEffect } from "react";
import "./Foodbeveragescompany.css";
import FoodProfile from './FoodProfile';
import Foodvereageprofile from './Foodvereageprofile.jsx';

/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
    return (
        <div className="dummy-box">
            <h2>{title}</h2>
            <p>This is a dummy section for <strong>{title}</strong>.</p>
            <span>Content will be added later 🚧</span>
        </div>
    );
};

/* ---------- Main Company Component ---------- */
const Company = () => {
    const [activeTab, setActiveTab] = useState(null);
    const [tabs, setTabs] = useState([]);

    // Define all available tabs with their submodule mapping
    const allTabs = [
        {
            id: 1,
            name: "Registration",
            component: () => <Foodvereageprofile title="Company Structure" />,
            subModuleKey: "REGISTRATION"
        },
        {
            id: 2,
            name: "About Us",
            component: () => <FoodProfile title="FOOD & BEVERAGES" />,
            subModuleKey: "ABOUT_US"
        },

    ];

    useEffect(() => {
        // Get user role and subModules from localStorage inside useEffect
        const userRole = localStorage.getItem("role");
        const subModules = JSON.parse(localStorage.getItem("subModules") || "[]");

        let availableTabs = [];

        // Check if user is employee
        if (userRole === "ROLE_EMPLOYEE") {
            // Filter tabs based on subModules from localStorage
            availableTabs = allTabs.filter(tab =>
                subModules.includes(tab.subModuleKey)
            );
        } else {
            // For vendors, show all tabs (no restrictions)
            availableTabs = [...allTabs];
        }

        setTabs(availableTabs);

        // Set active tab to first available tab if exists
        if (availableTabs.length > 0 && activeTab === null) {
            setActiveTab(availableTabs[0].id);
        }
    }, []); // Empty dependency array - only runs once on mount

    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

    // If no tabs available, show a message
    if (tabs.length === 0) {
        return (
            <div className="company-container">
                <div style={{
                    textAlign: "center",
                    padding: "50px",
                    color: "#64748b"
                }}>
                    <h3>No modules available</h3>
                    <p>You don't have access to any modules in this section.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="company-container">
            <style>{`


      }
        /* Default (Mobile first) */
        .company-scroll-container {
          position: static;
          background: #fff;
        }

        .company-buttons-row {
          display: flex;
          flex-wrap: wrap;
        }

        .company-button {
          padding: 8px 16px;
          border: none;
          background: #f0f0f0;
          cursor: pointer;
          border-radius: 6px;
          white-space: nowrap;
        }

        .company-button.active {
          background: #e66d33;
          color: #fff;
        }

        /* Desktop / Laptop only */
        @media (min-width: 769px) {
          .company-scroll-container {
            position: sticky;
            top: 0;
            z-index: 100;
            padding: 10px 0;
              background-color: #ffffff;
          }
        }
      `}</style>

            {/* Tabs */}
            <div className="company-scroll-container">
                <div className="company-buttons-row">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`company-button ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.name}
                        </button>
                    ))}
                </div>
            </div>

            {/* Active Section */}
            <div className="component-display" style={{
                height: window.innerHeight < 450 ? "50vh" : window.innerHeight < 500 ? "55vh" :
                    window.innerHeight < 520 ? "60vh" :
                        window.innerHeight < 540 ? "62vh" :
                            window.innerHeight < 560 ? "64vh" :
                                window.innerHeight < 580 ? "66vh" :
                                    window.innerHeight < 600 ? "68vh" :
                                        window.innerHeight < 620 ? "69vh" :
                                            window.innerHeight < 640 ? "69vh" :
                                                window.innerHeight < 660 ? "70vh" :
                                                    window.innerHeight < 680 ? "71vh" :
                                                        window.innerHeight < 700 ? "72vh" :
                                                            window.innerHeight < 720 ? "73vh" :
                                                                window.innerHeight < 740 ? "77vh" :
                                                                    window.innerHeight < 760 ? "80vh" :
                                                                        window.innerHeight < 780 ? "80vh" :
                                                                            window.innerHeight < 800 ? "80vh" : "80vh",
            }}>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default Company;